import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEEducationHistoriesCardActions = {
  initPeEducationHistoriesCard: ({ commit }, index) => {
    commit('setPeEducationHistoriesCardLock', { index, lock: true })
  },
  peEducationHistoriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        education_histories: {
          party_id: party.id,
          school: section.school,
          citystate: section.citystate,
          country_id: section.country_id,
          start_date: section.start_date,
          start_date_uncertain: section.start_date_uncertain,
          end_date: section.end_date,
          end_date_format: section.end_date_format,
          end_date_uncertain: section.end_date_uncertain,
          notes: section.notes,
        },
      }).
      then(({ data }) => {
        commit('setPeEducationHistoriesCardLock', { index: 'new', lock: true })
        commit('setPeEducationHistoriesCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'education_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peEducationHistoriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/education_histories/${section.id}`).
      then(({ data }) => {
        commit('setPeEducationHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'education_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peEducationHistoriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        education_histories: {
          party_id: party.id,
          school: section.school,
          citystate: section.citystate,
          country_id: section.country_id,
          start_date: section.start_date,
          start_date_format: section.start_date_format,
          start_date_uncertain: section.start_date_uncertain,
          end_date: section.end_date,
          end_date_format: section.end_date_format,
          end_date_uncertain: section.end_date_uncertain,
          notes: section.notes,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeEducationHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'education_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peEducationHistoriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          education_histories: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const educationHistories = data.education_histories

        commit('setPeEducationHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          education_histories: educationHistories || [],
        })
      }).
      catch(handleError)
  },
  peEducationHistoriesCardAddSection: ({ commit }) => {
    commit('setPeEducationHistoriesCardLock', { index: 'new', lock: false })
    commit('addPeEducationHistoriesCardSection', {
      id: null,
      school: null,
      citystate: null,
      country_id: null,
      start_date: null,
      start_date_format: null,
      start_date_uncertain: null,
      end_date: null,
      end_date_format: null,
      end_date_uncertain: null,
      notes: null,
    })
  },
}

export const PEEducationHistoriesCardMutations = {
  setPeEducationHistoriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.EducationHistoriesCard) {
      Vue.set(state.partyEdit.partySections, 'EducationHistoriesCard', {})
    }
    Vue.set(state.partyEdit.partySections.EducationHistoriesCard, index, lock)
  },
  addPeEducationHistoriesCardSection: (state, section) => {
    state.partyEdit.party.education_histories.push(section)
  },
  peEducationHistoriesCardCreateUndo: state => {
    state.partyEdit.party.education_histories.pop()
    Vue.set(state.partyEdit.partySections.EducationHistoriesCard, 'new', true)
  },
}

export const PEEducationHistoriesCardGetters = {
  peEducationHistoriesCardLock: state => index => state.partyEdit.partySections.EducationHistoriesCard[index],
  peEducationHistoriesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    education_histories?.
    find(language => language.id === null),
}
